/* eslint-disable no-underscore-dangle,jsdoc/require-description,
jsdoc/require-param,jsdoc/require-returns,graphql/template-strings */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// adopt
import { adopt } from 'react-adopt';
// graphQL
import gql from 'graphql-tag';
// global variables
import {
  defaultNumberOfRows as DEFAULT_NUMBER_OF_ROWS,
  adStatus,
} from 'config';
// our components
import qs, { getQueryString } from 'helpers/queryStrings';
import RouterContext from 'helpers/routerContext';
import AuthContext from 'helpers/authContext';
import { bulkUpdate } from 'helpers/updateMutationsHelper';
import { getDateFromDefaultOrInitialFilter } from 'helpers/dateHelper';
import { Query, Mutation } from 'components/common/Query';
import { CustomPageInfo as PageInfo } from 'components/common/Paginator';
import moment from 'moment';
import { ApolloConsumer } from 'react-apollo';
import AdList from './List';

/**
 * Query to fetch ads from api
 */
export const ADS_QUERY = gql`
  query AdminAdsList(
    $first: Int
    $after: String
    $last: Int
    $before: String
    $category: ID
    $subcategory: ID
    $province: ID
    $municipality: ID
    $titleDescription: String
    $id: ID
    $ip: String
    $isPaidAd: Boolean
    $hasImage: Boolean
    $hasFlag: Boolean
    $updatedOnGte: String
    $updatedOnLte: String
    $statusIn: [String]
    $hasUser: Boolean
    $emailTerm: String
    $phoneTerm: String
    $contactInfo: String
    $reviewed: Boolean
    $reviewerId: ID
    $reviewedOnGte: String
    $reviewedOnLte: String
    $sortOrder: OrderEnum
    $sortField: AdminAdTypeSortFields!
    $matchedRules: String
    $sameOwnerAds: ID
    $botScore: String
    $userId: ID
  ) {
    ads(
      first: $first
      after: $after
      last: $last
      before: $before
      category: $category
      subcategory: $subcategory
      province: $province
      municipality: $municipality
      titleDescription: $titleDescription
      id: $id
      ip: $ip
      hasImage: $hasImage
      hasFlag: $hasFlag
      updatedOnGte: $updatedOnGte
      updatedOnLte: $updatedOnLte
      statusIn: $statusIn
      hasUser: $hasUser
      emailTerm: $emailTerm
      phoneTerm: $phoneTerm
      isPaidAd: $isPaidAd
      contactInfo: $contactInfo
      reviewed: $reviewed
      reviewerId: $reviewerId
      reviewedOnGte: $reviewedOnGte
      reviewedOnLte: $reviewedOnLte
      sort: { order: $sortOrder, field: $sortField }
      matchedRules: $matchedRules
      sameOwnerAds: $sameOwnerAds
      botScore: $botScore
      userId: $userId
    ) @connection(key: "AdminAdsList_ads") {
      pageInfo {
        ...PaginatorCustomPageInfo
      }
      edges {
        node {
          id
          title
          subcategory {
            id
            title
            parentCategory {
              id
              title
            }
          }
          user {
            id
            fakeId
            publicId
            fullname
            email
            phone
          }
          reviewed
          reviewedOn
          updatedOn
          reviewedBy {
            id
            fullname
          }
          isAuto
          isPromoted
          matchedRules
          name
          firstPhone
          firstPhonePrefix
          secondPhone
          secondPhonePrefix
          email
          status
          flagCount
          updateCount
          botScoreUpdate
          botScoreInsert
          ipInsert
          ipUpdate
          countryInsert
          countryUpdate
          province {
            name
          }
          municipality {
            name
          }
        }
      }
      meta {
        total
      }
    }
  }
  ${PageInfo}
`;

export const ADS_IMAGES = gql`
  query AdsImages(
    $first: Int
    $after: String
    $last: Int
    $before: String
    $category: ID
    $subcategory: ID
    $province: ID
    $municipality: ID
    $titleDescription: String
    $id: ID
    $ip: String
    $isPaidAd: Boolean
    $hasImage: Boolean
    $hasFlag: Boolean
    $updatedOnGte: String
    $updatedOnLte: String
    $statusIn: [String]
    $hasUser: Boolean
    $emailTerm: String
    $phoneTerm: String
    $contactInfo: String
    $reviewed: Boolean
    $reviewerId: ID
    $reviewedOnGte: String
    $reviewedOnLte: String
    $sortOrder: OrderEnum
    $sortField: AdminAdTypeSortFields!
    $matchedRules: String
    $sameOwnerAds: ID
    $botScore: String
    $userId: ID
  ) {
    ads(
      first: $first
      after: $after
      last: $last
      before: $before
      category: $category
      subcategory: $subcategory
      province: $province
      municipality: $municipality
      titleDescription: $titleDescription
      id: $id
      ip: $ip
      hasImage: $hasImage
      hasFlag: $hasFlag
      updatedOnGte: $updatedOnGte
      updatedOnLte: $updatedOnLte
      statusIn: $statusIn
      hasUser: $hasUser
      emailTerm: $emailTerm
      phoneTerm: $phoneTerm
      isPaidAd: $isPaidAd
      contactInfo: $contactInfo
      reviewed: $reviewed
      reviewerId: $reviewerId
      reviewedOnGte: $reviewedOnGte
      reviewedOnLte: $reviewedOnLte
      sort: { order: $sortOrder, field: $sortField }
      matchedRules: $matchedRules
      sameOwnerAds: $sameOwnerAds
      botScore: $botScore
      userId: $userId
    ) @connection(key: "AdsImages_ads") {
      pageInfo {
        ...PaginatorCustomPageInfo
      }
      edges {
        node {
          id
          readyImages {
            id
            urls {
              high
              thumb
            }
          }
        }
      }
    }
  }
  ${PageInfo}
`;

/**
 * Mutation to review ads
 */
export const REVIEW_ADS_MUTATION = gql`
  mutation($ids: [ID]!) {
    reviewAd(input: { ids: $ids }) {
      successIds
      errors {
        field
        messages
      }
    }
  }
`;

/**
 * Mutation to unreview ads
 */
export const UNREVIEW_ADS_MUTATION = gql`
  mutation($ids: [ID]!) {
    unReviewAd(input: { ids: $ids }) {
      successIds
      errors {
        field
        messages
      }
    }
  }
`;

/**
 * Mutation to publish ads
 */
export const PUBLISH_ADS_MUTATION = gql`
  mutation($ids: [ID]!) {
    publishAd(input: { ids: $ids }) {
      successIds
      errors {
        field
        messages
      }
    }
  }
`;

/**
 * Mutation to publish ads
 */
export const UNPUBLISH_ADS_MUTATION = gql`
  mutation($ids: [ID]!) {
    unPublishAd(input: { ids: $ids }) {
      successIds
      errors {
        field
        messages
      }
    }
  }
`;

/**
 * Mutation to reprocess ads
 */
export const REPROCESS_ADS_MUTATION = gql`
  mutation($ids: [ID]!) {
    reprocessAd(input: { ids: $ids }) {
      successIds
      errors {
        field
        messages
      }
    }
  }
`;

/**
 * Mutation to change ad category
 */
export const CHANGE_AD_CATEGORY_MUTATION = gql`
  mutation($id: ID!, $subcategoryId: ID!) {
    changeAdCategory(input: { id: $id, subcategory: $subcategoryId }) {
      ad {
        id
      }
      errors {
        field
        messages
      }
    }
  }
`;

/**
 * Default filters in AdsList
 */
export const defaultFilters = {
  category: undefined,
  subcategory: undefined,
  province: undefined,
  municipality: undefined,
  titleDescription: undefined,
  id: undefined,
  ip: undefined,
  isAuto: undefined,
  hasImage: undefined,
  hasFlag: undefined,
  statusIn: undefined,
  hasUser: undefined,
  contactInfo: undefined,
  emailTerm: undefined,
  phoneTerm: undefined,
  reviewed: undefined,
  reviewerId: undefined,
  multipleSelectRules: [],
  rulesParams: [],
  sameOwnerAds: undefined,
  userId: undefined,
};

/**
 * @class
 * @augments Component
 */
class AdListContainer extends Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    const { initialFilters } = props;
    const defaultDateFilters = this.getDefaultDateFilters();
    const updatedOnGte = getDateFromDefaultOrInitialFilter({
      field: 'updatedOnGte',
      defaultDateFilters,
      initialFilters,
    });
    const updatedOnLte = getDateFromDefaultOrInitialFilter({
      field: 'updatedOnLte',
      defaultDateFilters,
      initialFilters,
    });
    const reviewedOnGte = getDateFromDefaultOrInitialFilter({
      field: 'reviewedOnGte',
      defaultDateFilters,
      initialFilters,
    });
    const reviewedOnLte = getDateFromDefaultOrInitialFilter({
      field: 'reviewedOnLte',
      defaultDateFilters,
      initialFilters,
    });
    const {
      appliedOrder,
      numberOfRowsSelected,
      direction,
      cursor,
      ...initFilters
    } = initialFilters;
    const filters = {
      ...defaultFilters,
      ...initFilters,
      updatedOnGte,
      updatedOnLte,
      reviewedOnGte,
      reviewedOnLte,
    };
    this.state = {
      numberOfRowsSelected:
        parseInt(numberOfRowsSelected, 0) || DEFAULT_NUMBER_OF_ROWS,
      appliedOrder: appliedOrder || {
        orderField: 'id',
        orderAsc: false,
        orderColumn: 'title',
      },
      filters,
      pagination: { direction: direction || null, cursor: cursor || undefined },
      itemProcessing: [],
      failedIds: [],
      showNotification: false,
      adImages: {},
    };
    this.Compose = adopt({
      mutateAdReview: this.adReview,
      mutateAdUnReview: this.adUnReview,
      mutateAdPublish: this.adPublish,
      mutateAdUnPublish: this.adUnPublish,
      mutateAdChangeCategory: this.adChangeCategory,
      mutateAdReprocess: this.adReprocess,
      query: this.listAds,
    });
    this.fetchMore = () => {};
  }

  /**
   * @description
   * Calc default date filters.
   *
   * @returns {Object} - Return default date filters.
   */
  getDefaultDateFilters = () => ({
    updatedOnGte: moment()
      .subtract(3, 'day')
      .startOf('day')
      .format(),
    updatedOnLte: moment()
      .endOf('day')
      .format(),
    reviewedOnGte: undefined,
    reviewedOnLte: undefined,
  });

  /**
   * @description
   * Build varaibles for queries
   *
   * @returns {Object} - Return variables.
   */
  getVariables = () => {
    const {
      appliedOrder: { orderField, orderAsc },
      filters,
      pagination,
      numberOfRowsSelected,
    } = this.state;
    const paginationVariables =
      !pagination.direction || pagination.direction === 'NEXT'
        ? {
            first: numberOfRowsSelected,
            after: pagination.cursor,
          }
        : {
            last: numberOfRowsSelected,
            before: pagination.cursor,
          };
    const latestMatchedRules = [
      ...filters.multipleSelectRules,
      ...filters.rulesParams,
    ].join(', ');

    return {
      ...filters,
      ...paginationVariables,
      sortField: orderField,
      sortOrder: orderAsc ? 'asc' : 'desc',
      matchedRules: latestMatchedRules !== '' ? latestMatchedRules : undefined,
      multipleSelectRules: undefined,
      rulesParams: undefined,
    };
  };

  getAdsImages = async client => {
    const variables = this.getVariables();

    // getting images from current filters
    const { data } = await client.query({
      query: ADS_IMAGES,
      variables,
      fetchPolicy: 'network-only',
    });
    const adImages = data.ads.edges.reduce(
      (previousValue, currentValue) => ({
        ...previousValue,
        [currentValue.node.id]: currentValue.node.readyImages.map(value => ({
          id: value.id,
          high: value.urls.high,
          thumb: value.urls.thumb,
        })),
      }),
      {},
    );

    this.setState({ adImages });
  };

  /**
   * @description
   * Query callback to compose with mutations.
   *
   * @param {*} render - Query's render props.
   * @returns {*} Query component.
   */
  listAds = ({ render }) => {
    const variables = this.getVariables();

    return (
      <ApolloConsumer>
        {client => (
          <Query
            query={ADS_QUERY}
            variables={variables}
            notifyOnNetworkStatusChange
            fetchPolicy="cache-and-network"
            onCompleted={() => this.getAdsImages(client)}
          >
            {({ data, loading, fetchMore }) => {
              this.fetchMore = fetchMore;
              return render({ data, loading, fetchMore });
            }}
          </Query>
        )}
      </ApolloConsumer>
    );
  };

  /**
   * @description
   * Mutation review callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adReview = ({ render }) => {
    const { itemProcessing, filters } = this.state;
    return (
      <AuthContext.Consumer>
        {({ id, fullname }) => (
          <Mutation
            mutation={REVIEW_ADS_MUTATION}
            onCompleted={this.mutationCompleted('reviewAd', itemProcessing)}
            update={(cache, { data: { reviewAd } }) => {
              const data = {
                reviewed: true,
                reviewedBy: { id, fullname, __typename: 'UserType' },
                reviewedOn: Date.now(),
                __typename: 'AdminAdType',
              };

              const field = `${'reviewed ' +
                'reviewedBy {id fullname} ' +
                'reviewedOn '}`;

              bulkUpdate(
                cache,
                'AdminAdType',
                'Review',
                field,
                data,
                reviewAd.successIds,
              );

              if (filters.reviewed === false) {
                const variables = { last: reviewAd.successIds.length };
                const { ads } = cache.readQuery({
                  query: ADS_QUERY,
                });

                const newEdges = ads.edges.filter(
                  edge => reviewAd.successIds.indexOf(edge.node.id) === -1,
                );

                cache.writeQuery({
                  query: ADS_QUERY,
                  data: {
                    ads: {
                      ...ads,
                      edges: newEdges,
                    },
                  },
                });

                this.fetchMore({
                  variables,
                  updateQuery: this.updateQuery,
                });
              }
            }}
          >
            {handleAdReview => render({ handleAdReview })}
          </Mutation>
        )}
      </AuthContext.Consumer>
    );
  };

  /**
   * @description
   * Mutation unreview callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adUnReview = ({ render }) => {
    const { itemProcessing, filters } = this.state;
    return (
      <AuthContext.Consumer>
        {() => (
          <Mutation
            mutation={UNREVIEW_ADS_MUTATION}
            onCompleted={this.mutationCompleted('unReviewAd', itemProcessing)}
            update={(cache, { data: { unReviewAd } }) => {
              const data = {
                reviewed: false,
                reviewedBy: null,
                reviewedOn: null,
                __typename: 'AdminAdType',
              };

              const field = `${'reviewed ' +
                'reviewedBy {id fullname}' +
                'reviewedOn '}`;

              bulkUpdate(
                cache,
                'AdminAdType',
                'Unreview',
                field,
                data,
                unReviewAd.successIds,
              );

              if (filters.reviewed === true) {
                const variables = { last: unReviewAd.successIds.length };
                const { ads } = cache.readQuery({
                  query: ADS_QUERY,
                });

                const newEdges = ads.edges.filter(
                  edge => unReviewAd.successIds.indexOf(edge.node.id) === -1,
                );

                cache.writeQuery({
                  query: ADS_QUERY,
                  data: {
                    ads: {
                      ...ads,
                      edges: newEdges,
                    },
                  },
                });

                this.fetchMore({
                  variables,
                  updateQuery: this.updateQuery,
                });
              }
            }}
          >
            {handleAdUnReview => render({ handleAdUnReview })}
          </Mutation>
        )}
      </AuthContext.Consumer>
    );
  };

  /**
   * @description
   * Mutation publish callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adPublish = ({ render }) => {
    const { itemProcessing, filters } = this.state;
    return (
      <Mutation
        mutation={PUBLISH_ADS_MUTATION}
        onCompleted={this.mutationCompleted('publishAd', itemProcessing)}
        update={(cache, { data: { publishAd } }) => {
          const data = {
            status: adStatus.PUBLISHED_BY_MODERATOR,
            __typename: 'AdminAdType',
          };

          bulkUpdate(
            cache,
            'AdminAdType',
            'Publish',
            'status',
            data,
            publishAd.successIds,
          );

          if (
            !filters.statusIn ||
            filters.statusIn.indexOf(adStatus.PUBLISHED_BY_MODERATOR) === -1
          ) {
            const variables = { last: publishAd.successIds.length };
            const { ads } = cache.readQuery({
              query: ADS_QUERY,
            });

            const newEdges = ads.edges.filter(
              edge => publishAd.successIds.indexOf(edge.node.id) === -1,
            );

            cache.writeQuery({
              query: ADS_QUERY,
              data: {
                ads: {
                  ...ads,
                  edges: newEdges,
                },
              },
            });

            this.fetchMore({
              variables,
              updateQuery: this.updateQuery,
            });
          }
        }}
      >
        {handleAdPublish => render({ handleAdPublish })}
      </Mutation>
    );
  };

  /**
   * @description
   * Mutation unpublish callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adUnPublish = ({ render }) => {
    const { itemProcessing, filters } = this.state;
    return (
      <Mutation
        mutation={UNPUBLISH_ADS_MUTATION}
        onCompleted={this.mutationCompleted('unPublishAd', itemProcessing)}
        update={(cache, { data: { unPublishAd } }) => {
          const data = {
            status: adStatus.UNPUBLISHED_BY_MODERATOR,
            __typename: 'AdminAdType',
          };

          bulkUpdate(
            cache,
            'AdminAdType',
            'Unpublish',
            'status',
            data,
            unPublishAd.successIds,
          );

          if (
            !filters.statusIn ||
            filters.statusIn.indexOf(adStatus.UNPUBLISHED_BY_MODERATOR) === -1
          ) {
            const variables = { last: unPublishAd.successIds.length };
            const { ads } = cache.readQuery({
              query: ADS_QUERY,
            });

            const newEdges = ads.edges.filter(
              edge => unPublishAd.successIds.indexOf(edge.node.id) === -1,
            );

            cache.writeQuery({
              query: ADS_QUERY,
              data: {
                ads: {
                  ...ads,
                  edges: newEdges,
                },
              },
            });

            this.fetchMore({
              variables,
              updateQuery: this.updateQuery,
            });
          }
        }}
      >
        {handleAdUnPublish => render({ handleAdUnPublish })}
      </Mutation>
    );
  };

  /**
   * @description
   * Mutation reprocess callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adReprocess = ({ render }) => {
    const { itemProcessing, filters } = this.state;
    return (
      <Mutation
        mutation={REPROCESS_ADS_MUTATION}
        onCompleted={this.mutationCompleted('reprocessAd', itemProcessing)}
        update={(cache, { data: { reprocessAd } }) => {
          const data = {
            status: adStatus.PENDING_PROCESSING,
            __typename: 'AdminAdType',
          };

          bulkUpdate(
            cache,
            'AdminAdType',
            'Reprocess',
            'status',
            data,
            reprocessAd.successIds,
          );

          if (
            !filters.statusIn ||
            filters.statusIn.indexOf(adStatus.PENDING_PROCESSING) === -1
          ) {
            const variables = { last: reprocessAd.successIds.length };
            const { ads } = cache.readQuery({
              query: ADS_QUERY,
            });

            const newEdges = ads.edges.filter(
              edge => reprocessAd.successIds.indexOf(edge.node.id) === -1,
            );

            cache.writeQuery({
              query: ADS_QUERY,
              data: {
                ads: {
                  ...ads,
                  edges: newEdges,
                },
              },
            });

            this.fetchMore({
              variables,
              updateQuery: this.updateQuery,
            });
          }
        }}
      >
        {handleAdReprocess => render({ handleAdReprocess })}
      </Mutation>
    );
  };

  /**
   * @description
   * Mutation to change ad category.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adChangeCategory = ({ render }) => (
    <Mutation mutation={CHANGE_AD_CATEGORY_MUTATION}>
      {handleAdChangeCategory => render({ handleAdChangeCategory })}
    </Mutation>
  );

  /**
   * @description
   * Handle change order.
   *
   * @param {Object} newOrder - Object that contain order mapping.
   */
  handleChangeOrder = newOrder => {
    const history = this.context;
    const {
      appliedOrder: { orderField, orderAsc },
    } = this.state;
    const appliedOrder = {
      orderField: newOrder.val,
      orderAsc: !(orderField === newOrder.val && orderAsc),
      orderColumn: newOrder.column,
    };
    this.setState({ appliedOrder });
    const currentLocation = history.location.pathname;
    const parsed = getQueryString(history);
    const stringified = qs.stringify({ ...parsed, appliedOrder });
    history.push({ pathname: currentLocation, search: stringified });
  };

  /**
   * @description
   * Query helpful function to update query's result.
   *
   * @param {Object} previousResult - Latest Query result.
   * @param {Object} options - UpdateQuery options.
   * @returns {Object} New or Previous query's result.
   */
  updateQuery = (previousResult, options) => {
    const { pageInfo, edges: newEdges, meta } = options.fetchMoreResult.ads;
    const existingIds = new Set(previousResult.ads.edges.map(e => e.node.id));
    const uniqueNewEdges = newEdges.filter(e => !existingIds.has(e.node.id));
    return {
      ads: {
        __typename: previousResult.ads.__typename,
        edges: [...previousResult.ads.edges, ...uniqueNewEdges],
        pageInfo: {
          ...previousResult.ads.pageInfo,
          hasNextPage: pageInfo.hasNextPage,
        },
        meta: meta || previousResult.ads.meta,
      },
    };
  };

  /**
   * @description
   * OnComplete delete mutation.
   *
   * @param {Object} field - Target field of mutation.
   * @param {Object} itemProcessing - Ids of items that is processing.
   * @returns {undefined} - No returns value.
   */
  mutationCompleted = (field, itemProcessing) => async data => {
    const failedIds = itemProcessing.filter(
      item => !data[field].successIds.includes(item),
    );
    this.setState({
      itemProcessing: [],
      failedIds,
      showNotification: failedIds.length > 0,
    });
  };

  /**
   * @description
   * Filter rows according selected filters.
   *
   * @param {Object} filters - Filters to apply.
   */
  handleFilter = filters => {
    const history = this.context;
    const {
      updatedOnGte,
      updatedOnLte,
      reviewedOnGte,
      reviewedOnLte,
      ...rest
    } = filters;
    this.setState({
      filters: {
        ...defaultFilters,
        updatedOnGte: updatedOnGte === null ? undefined : updatedOnGte,
        updatedOnLte: updatedOnLte === null ? undefined : updatedOnLte,
        reviewedOnGte: reviewedOnGte === null ? undefined : reviewedOnGte,
        reviewedOnLte: reviewedOnLte === null ? undefined : reviewedOnLte,
        ...rest,
      },
      pagination: { direction: null, cursor: undefined },
    });
    const currentLocation = history.location.pathname;
    const { appliedOrder, numberOfRowsSelected } = getQueryString(history);

    const stringified = qs.stringify({
      updatedOnGte: updatedOnGte === null ? 'null' : updatedOnGte,
      updatedOnLte: updatedOnLte === null ? 'null' : updatedOnLte,
      reviewedOnGte: reviewedOnGte === null ? 'null' : reviewedOnGte,
      reviewedOnLte: reviewedOnLte === null ? 'null' : reviewedOnLte,
      ...rest,
      appliedOrder,
      numberOfRowsSelected,
      direction: undefined,
      cursor: undefined,
    });
    history.push({ pathname: currentLocation, search: stringified });
  };

  /**
   * @description
   * Change state to restart filters.
   */
  handleRestartFilters = () => {
    const history = this.context;
    const defaultDateFilters = this.getDefaultDateFilters();
    this.setState({
      filters: { ...defaultFilters, ...defaultDateFilters },
      pagination: { direction: null, cursor: undefined },
    });
    const currentLocation = history.location.pathname;
    const { appliedOrder, numberOfRowsSelected } = getQueryString(history);
    const stringified = qs.stringify({
      appliedOrder,
      numberOfRowsSelected,
    });
    history.push({ pathname: currentLocation, search: stringified });
  };

  /**
   * @description
   * Change number of rows selected.
   *
   * @param {number} selectedItem - New number of rows selected.
   */
  handleChangeNumberOfRows = selectedItem => {
    const history = this.context;
    this.setState({
      numberOfRowsSelected: selectedItem,
      pagination: { direction: null, cursor: undefined },
    });
    const currentLocation = history.location.pathname;
    const parsed = getQueryString(history);
    const stringified = qs.stringify({
      ...parsed,
      updatedOnGte: parsed.updatedOnGte === null ? 'null' : parsed.updatedOnGte,
      updatedOnLte: parsed.updatedOnLte === null ? 'null' : parsed.updatedOnLte,
      numberOfRowsSelected: selectedItem,
      direction: undefined,
      cursor: undefined,
    });
    history.push({ pathname: currentLocation, search: stringified });
  };

  /**
   * @description
   * Fetch more rows when user change page.
   *
   * @param {Object} paginatorVariables - Pagination query's variables.
   */
  handleChangePage = ({ direction, cursor }) => {
    const history = this.context;
    this.setState({ pagination: { direction, cursor } });
    const currentLocation = history.location.pathname;
    const parsed = getQueryString(history);
    const stringified = qs.stringify({
      ...parsed,
      updatedOnGte: parsed.updatedOnGte === null ? 'null' : parsed.updatedOnGte,
      updatedOnLte: parsed.updatedOnLte === null ? 'null' : parsed.updatedOnLte,
      direction,
      cursor,
    });
    history.push({ pathname: currentLocation, search: stringified });
  };

  /**
   * @description
   * Refresh the list.
   * @returns {Function} - Fetch More function.
   */
  handleRefresh = () => {
    this.fetchMore({
      updateQuery: (_, { fetchMoreResult }) => fetchMoreResult,
    });
  };

  /**
   * @description
   * Close notification.
   * @returns {undefined} - No returns value.
   */
  handleCloseNotification = () => {
    this.setState({ showNotification: false });
  };

  /**
   * @description
   * Render AdsList component.
   */
  render() {
    const {
      numberOfRowsSelected,
      appliedOrder,
      filters,
      itemProcessing,
      failedIds,
      pagination,
      showNotification,
      adImages,
    } = this.state;
    return (
      <this.Compose>
        {({
          mutateAdReview: { handleAdReview },
          mutateAdUnReview: { handleAdUnReview },
          mutateAdPublish: { handleAdPublish },
          mutateAdUnPublish: { handleAdUnPublish },
          mutateAdChangeCategory: { handleAdChangeCategory },
          mutateAdReprocess: { handleAdReprocess },
          query: { data, loading },
        }) => (
          <AdList
            data={data}
            adsImages={adImages}
            appliedOrder={appliedOrder}
            changeOrder={this.handleChangeOrder}
            adReview={items => {
              this.setState({
                itemProcessing: [...itemProcessing, ...items],
                failedIds: [],
              });
              handleAdReview({ variables: { ids: items } });
            }}
            adUnReview={items => {
              this.setState({
                itemProcessing: [...itemProcessing, ...items],
                failedIds: [],
              });
              handleAdUnReview({ variables: { ids: items } });
            }}
            adPublish={items => {
              this.setState({
                itemProcessing: [...itemProcessing, ...items],
                failedIds: [],
              });
              handleAdPublish({ variables: { ids: items } });
            }}
            adUnPublish={items => {
              this.setState({
                itemProcessing: [...itemProcessing, ...items],
                failedIds: [],
              });
              handleAdUnPublish({ variables: { ids: items } });
            }}
            adReprocess={items => {
              this.setState({
                itemProcessing: [...itemProcessing, ...items],
                failedIds: [],
              });
              handleAdReprocess({ variables: { ids: items } });
            }}
            adApplyRuleAndPublish={(items, subcategoryId) => {
              this.setState({
                itemProcessing: [...itemProcessing, ...items],
                failedIds: [],
              });
              if (!subcategoryId || !items || items.length === 0) {
                handleAdPublish({ variables: { ids: items } });
                return;
              }
              handleAdChangeCategory({
                variables: {
                  id: `${items[0]}`,
                  subcategoryId: `${subcategoryId}`,
                },
              })
                .then(({ data: mutationData }) => {
                  if (
                    mutationData &&
                    mutationData.changeAdCategory &&
                    mutationData.changeAdCategory.errors
                  ) {
                    this.setState({
                      itemProcessing: [],
                      failedIds: items,
                      showNotification: true,
                    });
                    return;
                  }
                  handleAdPublish({ variables: { ids: items } });
                })
                .catch(() => {
                  this.setState({
                    itemProcessing: [],
                    failedIds: items,
                    showNotification: true,
                  });
                });
            }}
            numberOfRowsSelected={numberOfRowsSelected}
            paginationDirection={pagination.direction}
            changePage={paginationVariables => {
              this.handleChangePage(paginationVariables);
            }}
            changeNumberOfRows={this.handleChangeNumberOfRows}
            appliedFilter={filters}
            filter={this.handleFilter}
            refresh={this.handleRefresh}
            restartFilters={this.handleRestartFilters}
            loading={Object.keys(data).length === 0}
            fullLoading={loading}
            itemProcessing={itemProcessing}
            failedIds={failedIds}
            showNotification={showNotification}
            closeNotification={this.handleCloseNotification}
          />
        )}
      </this.Compose>
    );
  }
}

/**
 * AdListContainer PropTypes
 * @param initialFilters - prop initial Filters to apply
 */

AdListContainer.propTypes = {
  initialFilters: PropTypes.shape({}).isRequired,
};

export default AdListContainer;
